export default {
  namespaced: true,
  state () {
    return {
      login: "",
    }
  },
  actions: {
    updateLogin (context, payload) {
      context.commit("updateLogin", payload)
    },
  },
  getters: {
    getLogin (state) {
      return state.login
    },
  },
  mutations: {
    updateLogin (state, payload) {
      state.login = payload.replace(/[+()-]/g, '')
    },
  },
}
